/**
 * Created by neo on 09.11.21.
 */

export type MediaVisibleRect = {
  top: number;
  left: number;
  bottom: number;
  right: number;
};

/** @deprecated Use raw object instead */
export function createMediaVisibleRect(json?: Partial<MediaVisibleRect>): MediaVisibleRect {
  return {
    top: json?.top ?? 0,
    left: json?.left ?? 0,
    bottom: json?.bottom ?? 0,
    right: json?.right ?? 0,
  };
}
